module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-greek15.3efbf9f.woff2";